import { FabricChannel } from '@atlaskit/analytics-listeners/types';

export const EVENT_CHANNEL = FabricChannel.peopleTeams;
